import { styled } from '@mui/material/styles';
import { Typography } from '@mui/material';
import { DS_typography as coreTypography } from 'mui/base/theme/DS_Tokens/core';

export const StyledOpeningHoursContainer = styled('div')(
  ({ theme }) => `
    border-radius: 0.75rem;
    border: 1px solid ${theme.DS_palette.border.light};
    padding: ${theme.DS_spacing(['md'])};
    margin-top: ${theme.DS_spacing(['md'])};
    
    ${theme.breakpoints.up('lg')} {
      margin-top: ${theme.DS_spacing(['lgx'])};
    }
  `,
);

export const StyledOpeningHoursHeading = styled(Typography)(
  ({ theme }) => `
    color: ${theme.DS_palette.cards.attention};
  `,
);

export const StyledOpeningHours = styled('div')(
  ({ theme }) => `
    ul {
      display: flex;
      flex-flow: column nowrap;
    
      li {
        border-radius: 6px;
        background-color: ${theme.DS_palette.background.light};
        display: flex;
        padding: ${theme.DS_spacing(['xxs'])} ${theme.DS_spacing(['sm'])};
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: flex-start;
        gap: ${theme.DS_spacing(['xxxs'])};
        align-self: stretch;
        margin-top: 0.75rem;
        
        span {
          display: block;
          text-transform: lowercase;
  
          &::first-line {
            text-transform: capitalize;
          }
          &:first-of-type {
            font-weight: ${coreTypography.fontWeight.bold};
            line-height: ${coreTypography.lineHeight.lvl5};
            flex: 1 0 100%;
            ${theme.breakpoints.up('lg')} {
              font-size: ${coreTypography.fontSize.lvl4};
              line-height: ${coreTypography.lineHeight.lvl6};
            }
          }
          &:nth-child(3), &:nth-child(4) {
           padding-left: ${theme.DS_spacing(['xs'])};
          }
          &:not(:first-of-type) {
            color: ${theme.DS_palette.text.secondary};
            font-weight: ${coreTypography.fontWeight.medium};
            line-height: ${coreTypography.lineHeight.lvl5};
      
            ${theme.breakpoints.up('lg')} {
              font-size: ${coreTypography.fontSize.lvl4};
              line-height: ${coreTypography.lineHeight.lvl8};
            }
          }
        }
      }
    }
    
    ${theme.breakpoints.up('lg')} {
      ul {
        flex-flow: row wrap;
        gap: 0.75rem;
        
        li {
          display: flex;
          flex-direction: column !important;
          align-items: center;
          padding: ${theme.DS_spacing(['sm'])} ${theme.DS_spacing(['xs'])}; 
          flex-basis: calc(20% - 0.75rem); 
          white-space: nowrap;
          
          span {
          &:first-of-type{
           flex: revert;
          }
          &:nth-child(3), &:nth-child(4) {
              padding-left: 0;
          }
          }
        }
      }
    }
  `,
);
